module.exports = __webpack_public_path__ + "static/elephant-1080-ccbc9c17332fc2006effd5f39a5da194.webm";